<div class="edit-model-security-allocations-component" id="edit-model-security-allocations-component">
  <div class="block">
    @if (data) {
      <div class="assignAccountsCountText" >
        <span id="securitiesRowcount">{{rowCount}}</span> Securities
      </div>
    }

    <div class="d-flex">
      <div>
        Add securities to this model:
        <irb-dropdown-search-multiple #securitiesDropdown [(values)]="securitiesList" [enableHiddenSearchResults]="true"
          [addNewItem]="addNewSecurityItem"
          (openNewItemFlow)="openNewItemSecurityFlow($event)"
          (search)="getSecurities($event)" (selection)="onSecuritiesChange($event)"
          style="width: 300px !important;vertical-align: middle;" size="30">
        </irb-dropdown-search-multiple>
        <button (click)="addSecuritiesFromDropdown()" [disabled]="securitiesList ? securitiesList.length === 0 : true"
          class="btn-medium-secondary">Add
        </button>
        <button id="advancedFilterButton" (click)="showAddMultipleSecuritiesDialog()" class="btn-medium-secondary">
          Advanced Filter
        </button>
        <!--<button id="editorCreateNewButton" (click)="onCreateNewSecurity()" class="btn-medium-secondary">New Security</button>-->
      </div>
      <div class="btn-group ml-auto">
        <button [class.active]="defaultView === SecurityAllocationViewStateEnum.BASIC_VIEW" (click)="enableBasicView()">Basic View</button>
        <button [class.active]="defaultView === SecurityAllocationViewStateEnum.TRADING_VIEW" (click)="enableTradingView()">All Trading Rules</button>
      </div>
    </div>
  </div>

  @if (defaultView === SecurityAllocationViewStateEnum.BASIC_VIEW) {
    @if (!isUiTest) {
      <irb-inventory-grid id="edit-security-allocation-grid"
        [style.height] = "height"
        [showSideBar] ='true'
        [gridOptions] = "gridOptionsTop"
        [componentName]="componentName"
        [frameworkComponents] = 'frameworkComponents'
        (cellValueChanged)="onCellValueChanged()"
      (gridReady) = "onGridReady($event)"></irb-inventory-grid>
    }
  } @else {
    @if (!isUiTest) {
      <irb-inventory-grid id="edit-security-allocation-grid"
        [style.height] = "height"
        [showSideBar] ='true'
        [gridOptions] = "gridOptionsTop"
        [componentName]="componentName"
        [frameworkComponents] = 'frameworkComponents'
        (cellValueChanged)="onCellValueChanged()"
      (gridReady) = "onGridReady($event)"></irb-inventory-grid>
    }
  }


  <div class="edit-sec-allocation-totas-row" >
    <div style="position: relative;margin-bottom:10px;">
      Total Security Allocations:
      <div style="position: absolute;top: 3px; text-align:right;padding-right:8px;"
        id="edit-secallocation-grid-totalper"
      [ngStyle]="{color: totalPercent === 100 ? '#188800' : '#C11312'}"></div>
    </div>

    <div style="display: none;align-items: center;font-weight: bold;position: relative;">
      <button (click)="getFinMasonScore()"
        [disabled]="totalPercent === 100 && !isSubscribeModel ? false : true"
      class="btn-medium-secondary">Get</button>
      <div style="padding:0 10px;" >FinMason FinScore:</div>
      <div class="infoIcon" style="padding:0 10px;" calltoaction [calltoactionTemplate]="irbFinScoreTemplateRef">
        <div class="infoIcon" style="margin-left: 10px;padding-right:14px;"></div>
      </div>
      <ng-template #irbFinScoreTemplateRef >
        <div [innerHTML]="finscoreToolTip"></div>
      </ng-template>
      <div style="position: absolute;top: 3px;left:230px;text-align:right;padding-right:8px;" id="edit-secallocation-finscore-totalper">{{ finScore }}</div>
    </div>
  </div>

  <irb-common-dialog #dialog></irb-common-dialog>
</div>

